import React, { useEffect, useState, useRef, useContext } from 'react'
import './Chatbox.css'
import logo from '../../images/logo-icon.png'
import smallimg from '../../images/image (25).png'
import smallimg2 from '../../images/image (27).png'
import ellipse from '../../images/Ellipse 76.png'
import plus from '../../images/plus (3) 1.png'
import { reactLocalStorage } from "reactjs-localstorage";
import toast from 'react-hot-toast'
import HttpClient from '../../utils/HttpClient'
import { database, ref, push, set, onValue, off, update } from '../../FireBase/FirebaseChat';
import { formatDate } from '../../Helper/Helper';
import FisProjectsIcon from "../../images/fisi_white_icon.png";
import { UserContext } from '../../Providers/UserWrapper'
import ChatBoxModal from './ChatBoxModal'
import { useDispatch } from 'react-redux'
import { set_all_user_ids } from '../../redux/reducers/sentimentSlice'

const Chatbox = () => {
    const dispatch = useDispatch();
    const [openChat, setOpenChat] = useState(false);
    const [opensmallChat, setopensmallChat] = useState(false);
    const [msg, setMsg] = useState('');
    const [userList, setUserList] = useState([]);
    const [selectedReceiver, setSelectedReceiver] = useState(null);
    const [messages, setMessages] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [filteredUser, setFilteredUser] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loader, setLoader] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [fileType, setFileType] = useState(null);
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState('');
    const [conversations, setConversations] = useState([]);
    const [unreadMessageLength, setUnreadMessageLength] = useState(0);
    const { profileData, getProfile } = useContext(UserContext);
    const userAccountTypes = ['Manager', 'Bookkeeper', 'Staff'];
    const [assignedProjects, setAssignedProjects] = useState([]);
    const messagesEndRef = useRef(null);

    const chatboxRef = useRef(null);
    const smallChatRef = useRef(null);


    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (opensmallChat &&
                smallChatRef.current &&
                !smallChatRef.current.contains(event.target) &&
                chatboxRef.current &&
                !chatboxRef.current.contains(event.target)) {
                setopensmallChat(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [opensmallChat]);

    // Scroll to bottom function
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, opensmallChat]);

    useEffect(() => {
        setFilteredUser(userList);
    }, [userList]);

    useEffect(() => {
        const userData = reactLocalStorage.getObject("userData");
        const userEmail = localStorage.getItem('userEmail');

        if (userData?.token) {
            setCurrentUser({
                email: userEmail,
                id: userData.id || Math.random().toString(36).substring(7)
            });
        }
    }, [localStorage.getItem('userEmail')]);

    // Fetch conversations for the current user
    useEffect(() => {
        if (!currentUser) return;

        const cleanCurrentEmail = cleanEmailForPath(currentUser.email);
        const conversationsRef = ref(database, `conversations/${cleanCurrentEmail}`);

        const listener = onValue(conversationsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const convs = Object.keys(data).map(key => ({
                    chatId: key,
                    ...data[key]
                })).sort((a, b) => b.timestamp - a.timestamp); // Sort by most recent

                setConversations(convs);
            } else {
                setConversations([]);
            }
        });

        return () => off(conversationsRef, listener);
    }, [currentUser]);

    // Merge user list with conversation data
    useEffect(() => {
        if (userList.length === 0 || conversations.length === 0) return;

        // Create a map to ensure each user only appears once
        const userMap = new Map();

        // First add all users from userList
        userList.forEach(user => {
            userMap.set(user.email, {
                ...user,
                lastMessage: '',
                timestamp: 0,
                unread: false
            });
        });

        // Then update with conversation data
        conversations.forEach(conv => {
            const userEmail = conv.withUser;
            if (userMap.has(userEmail)) {
                userMap.set(userEmail, {
                    ...userMap.get(userEmail),
                    lastMessage: conv.lastMessage,
                    timestamp: conv.timestamp,
                    unread: conv.read === false
                });
            }
        });

        // Convert map values to array and sort
        const mergedUsers = Array.from(userMap.values()).sort((a, b) => {
            // Sort by unread first, then by timestamp
            if (a.unread && !b.unread) return -1;
            if (!a.unread && b.unread) return 1;
            return (b.timestamp || 0) - (a.timestamp || 0);
        });

        setFilteredUser(mergedUsers);
    }, [userList, conversations]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toast.error("File size should be less than 5MB");
            return;
        }

        const validTypes = [
            'image/jpeg',
            'image/png',
            'image/gif',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];

        if (!validTypes.includes(file.type)) {
            toast.error("Only images (JPEG, PNG, GIF), PDFs, and Word docs are allowed");
            return;
        }

        setFileName(file.name);

        if (file.type.startsWith('image/')) {
            setFileType('image');
            const reader = new FileReader();
            reader.onload = (event) => {
                setPreviewUrl(event.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            setFileType('document');
            setPreviewUrl(URL.createObjectURL(file));
        }
    };
    useEffect(() => {
        if (filteredUser && Array.isArray(filteredUser)) {
            dispatch(set_all_user_ids(filteredUser?.map(user => user?._id)));
        }
    }, [filteredUser]);

    // store message in mongoDB database for sentiment analysis ...
    const handleSendMessageForSentimentAnalysis = async sendData => {
        try {
            const res = await HttpClient.requestData("send", "POST", sendData);
            if (res) {
                dispatch(set_all_user_ids(filteredUser?.map(user => user?._id)));
            } else {
                toast.error(res?.message || "something went wrong!!!");
            }
        } catch (error) {
            toast.error(error?.message || "something went wrong!!!");
        }
    };

    const sendMessage = async () => {
        if (Object.keys(reactLocalStorage.getObject("userData"))?.length < 1) {
            toast.error("Please login to access chat");
            return;
        }

        if ((!msg.trim() && !previewUrl) || !currentUser || !selectedReceiver) {
            toast.error("Message or file cannot be empty or no recipient selected");
            return;
        }

        try {
            const chatId = generateChatId(currentUser.email, selectedReceiver.email);
            const cleanChatId = cleanPathSegment(chatId);

            if (!cleanChatId) {
                toast.error("Invalid recipient selected");
                return;
            }

            const messagesRef = ref(database, `chats/${cleanChatId}/messages`);
            const newMessageRef = push(messagesRef);

            const messageData = {
                text: msg,
                sender: currentUser.email,
                receiver: selectedReceiver.email,
                timestamp: Date.now(),
                read: false,
                fileType: previewUrl ? fileType : null,
                fileUrl: previewUrl || null,
                fileName: fileName || null
            };
            // console.log("messageData: ", messageData);
            handleSendMessageForSentimentAnalysis({
                text: messageData?.text,
                sender: messageData?.sender,
                receiver: messageData?.receiver,
            });

            set(newMessageRef, messageData)
                .then(() => {
                    console.log("Message sent successfully");
                    setMsg("");
                    setPreviewUrl(null);
                    setFileType(null);
                    setFileName('');
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }

                    updateConversationList(cleanChatId, {
                        ...messageData,
                        id: newMessageRef.key
                    });
                })
                .catch((error) => {
                    console.error("Error sending message: ", error);
                    toast.error(`Failed to send message: ${error.message}`);
                });
        } catch (error) {
            console.error("Error sending message: ", error);
            toast.error(`Failed to send message: ${error.message}`);
        }
    };

    const cleanPathSegment = (segment) => {
        if (!segment) return '';
        return segment.toString()
            .replace(/[.#$/[\]]/g, '_')
            .replace(/\s+/g, '_')
            .replace(/\/+/g, '_')
            .replace(/^_+|_+$/g, '');
    };

    const cleanEmailForPath = (email) => {
        return cleanPathSegment(email);
    };

    const generateChatId = (email1, email2) => {
        const cleanEmail1 = cleanEmailForPath(email1);
        const cleanEmail2 = cleanEmailForPath(email2);
        const sortedEmails = [cleanEmail1, cleanEmail2].sort();
        return `${sortedEmails[0]}_${sortedEmails[1]}`;
    };

    const updateConversationList = (chatId, lastMessage) => {
        const cleanCurrentEmail = cleanEmailForPath(currentUser.email);
        const conversationRef = ref(database, `conversations/${cleanCurrentEmail}/${chatId}`);

        const conversationData = {
            withUser: selectedReceiver.email,
            lastMessage: lastMessage.text || (lastMessage.fileType ? `Sent a ${lastMessage.fileType}` : ''),
            timestamp: lastMessage.timestamp,
            read: false
        };

        set(conversationRef, conversationData)
            .catch((error) => {
                console.error("Error updating conversation list: ", error);
            });

        // Also update the receiver's conversation list
        const cleanReceiverEmail = cleanEmailForPath(selectedReceiver.email);
        const receiverConversationRef = ref(database, `conversations/${cleanReceiverEmail}/${chatId}`);

        const receiverConversationData = {
            withUser: currentUser.email,
            lastMessage: lastMessage.text || (lastMessage.fileType ? `Sent a ${lastMessage.fileType}` : ''),
            timestamp: lastMessage.timestamp,
            read: false
        };

        set(receiverConversationRef, receiverConversationData)
            .catch((error) => {
                console.error("Error updating receiver's conversation list: ", error);
            });
    };

    useEffect(() => {
        if (!currentUser || !selectedReceiver) return;

        const chatId = generateChatId(currentUser.email, selectedReceiver.email);
        const cleanChatId = cleanPathSegment(chatId);

        if (!cleanChatId) {
            console.error("Invalid chat ID generated");
            return;
        }

        const messagesRef = ref(database, `chats/${cleanChatId}/messages`);

        const listener = onValue(messagesRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const msgs = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                })).sort((a, b) => a.timestamp - b.timestamp);

                setMessages(msgs);
                markMessagesAsRead(chatId, msgs);
            } else {
                setMessages([]);
            }
        });

        return () => off(messagesRef, listener);
    }, [currentUser, selectedReceiver]);

    const markMessagesAsRead = (chatId, messages) => {
        if (!currentUser || !messages || messages.length === 0) return;

        const updates = {};
        const cleanChatId = cleanPathSegment(chatId);
        const cleanCurrentEmail = cleanEmailForPath(currentUser.email);

        // Mark all unread messages from this sender as read
        messages.forEach(msg => {
            if (msg.receiver === currentUser.email && !msg.read) {
                const cleanMessageId = cleanPathSegment(msg.id);
                if (cleanChatId && cleanMessageId) {
                    const path = `chats/${cleanChatId}/messages/${cleanMessageId}/read`;
                    if (!path.match(/[.#$/[\]]/)) {
                        updates[path] = true;
                    }
                }
            }
        });

        // Update all messages at once
        if (Object.keys(updates).length > 0) {
            update(ref(database), updates).catch(error => {
                console.error("Error marking messages as read:", error);
            });

            // Update the conversation as read
            const conversationRef = ref(database, `conversations/${cleanCurrentEmail}/${cleanChatId}/read`);
            set(conversationRef, true).catch(error => {
                console.error("Error marking conversation as read:", error);
            });
        }
    };

    const fetchAllUserList = async () => {
        setLoader(true);
        try {
            const res = await HttpClient.requestData("alluserlist", "GET", {});
            if (res && res.status) {
                let finalUserList = [];
                if (res?.data?.clients) {
                    finalUserList = [...finalUserList, ...res?.data?.clients];
                }
                if (res?.data?.bookkeepers) {
                    finalUserList = [...finalUserList, ...res?.data?.bookkeepers];
                }
                if (res?.data?.investors) {
                    finalUserList = [...finalUserList, ...res?.data?.investors];
                }
                if (res?.data?.owners) {
                    finalUserList = [...finalUserList, ...res?.data?.owners];
                }
                if (res?.data?.managers) {
                    finalUserList = [...finalUserList, ...res?.data?.managers];
                }
                if (res?.data?.staffs) {
                    finalUserList = [...finalUserList, ...res?.data?.staffs];
                }
                if (res?.data?.assignUsers) {
                    const updatedAssignedUsers = res?.data?.assignUsers?.map(item => ({
                        ...item,
                        teamMember: "Team Member",
                    }));
                    finalUserList = [...finalUserList, ...updatedAssignedUsers];
                }

                // console.log("finalUserList: ", finalUserList);
                setUserList(finalUserList);
            } else {
                setUserList([]);
            }
        } catch (error) {
            toast.error(error?.message || "Something Went Wrong!!!");
            setUserList([]);
        } finally {
            setLoader(false);
        }
    };

    // console.log('users: ', users);

    useEffect(() => {
        if (currentUser) {
            fetchAllUserList();
        }
    }, [currentUser]);


    const handleChatClick = () => {
        setFilteredUser('');
        fetchAllUserList();
        setOpenChat(!openChat);
        setopensmallChat(false);
    };

    // const selectUser = (user) => {
    //     setSelectedReceiver(user);
    //     setopensmallChat(true);
    // };


    const selectUser = (user) => {
        setSelectedReceiver(user);
        setopensmallChat(true);

        // Immediately mark the conversation as read in the conversation list
        if (currentUser) {
            const chatId = generateChatId(currentUser.email, user.email);
            const cleanChatId = cleanPathSegment(chatId);
            const cleanCurrentEmail = cleanEmailForPath(currentUser.email);

            // Update the conversation as read
            const conversationRef = ref(database, `conversations/${cleanCurrentEmail}/${cleanChatId}/read`);
            set(conversationRef, true).catch(error => {
                console.error("Error marking conversation as read:", error);
            });

            // Also mark all messages as read
            const messagesRef = ref(database, `chats/${cleanChatId}/messages`);
            onValue(messagesRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const msgs = Object.keys(data).map(key => ({
                        id: key,
                        ...data[key]
                    }));
                    markMessagesAsRead(chatId, msgs);
                }
            }, { onlyOnce: true });
        }
    };

    useEffect(() => {
        if (searchTerm?.length) {
            setFilteredUser(userList.filter(user =>
                user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (user.userType && user.userType.toLowerCase().includes(searchTerm.toLowerCase()))
            ));
        } else {
            setFilteredUser(userList);
        }
    }, [searchTerm]);

    const renderFilePreview = () => {
        if (!previewUrl || !fileType) return null;

        if (fileType === 'image') {
            return (
                <div className="file-preview-container">
                    <img src={previewUrl} alt="Preview" className="file-preview-image" />
                    <button
                        onClick={() => {
                            setPreviewUrl(null);
                            setFileType(null);
                            setFileName('');
                            if (fileInputRef.current) {
                                fileInputRef.current.value = '';
                            }
                        }}
                        className="file-preview-remove"
                    >
                        ×
                    </button>
                </div>
            );
        } else {
            return (
                <div className="file-preview-container">
                    <div className="file-preview-document">
                        <i className="fa-solid fa-file"></i>
                        <span>{fileName || "Document attached"}</span>
                    </div>
                    <button
                        onClick={() => {
                            setPreviewUrl(null);
                            setFileType(null);
                            setFileName('');
                            if (fileInputRef.current) {
                                fileInputRef.current.value = '';
                            }
                        }}
                        className="file-preview-remove"
                    >
                        ×
                    </button>
                </div>
            );
        }
    };

    const downloadFile = (fileUrl, fileName) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderMessageContent = (message) => {
        if (message.fileUrl) {
            if (message.fileType === 'image') {
                return (
                    <div className="message-file-content">
                        <img
                            src={message.fileUrl}
                            alt="Sent content"
                            className="message-file-image"
                            onClick={() => downloadFile(message.fileUrl, message.fileName || 'image')}
                            style={{ cursor: 'pointer' }}
                        />
                        {message.text && <div className="message-file-caption">{message.text}</div>}
                        <div className="download-hint">Click image to download</div>
                    </div>
                );
            } else {
                return (
                    <div className="message-file-content">
                        <div
                            className="message-file-document"
                            onClick={() => downloadFile(message.fileUrl, message.fileName || 'document')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="fa-solid fa-file"></i>
                            <span>{message.fileName || "Document"}</span>
                        </div>
                        {message.text && <div className="message-file-caption">{message.text}</div>}
                        <div className="download-hint">Click to download</div>
                    </div>
                );
            }
        }
        return message.text;
    };

    // Handle click outside for main chat list
    useEffect(() => {
        const handleClickOutsideMainChat = (event) => {
            if (openChat &&
                chatboxRef.current &&
                !chatboxRef.current.contains(event.target)) {
                setOpenChat(false);
                setModalIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsideMainChat);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideMainChat);
        };
    }, [openChat]);


    // console.log("messages:>>>>> ", messages);

    const [modalIsopen, setModalIsOpen] = useState(false);

    // Create a custom hook
    const useOutsideClick = (ref, callback) => {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    callback();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, callback]);
    };

    const chatBoxModalRef = useRef();

    useOutsideClick(chatBoxModalRef, () => {
        if (modalIsopen) {
            setModalIsOpen(false);
        }
    });

    console.log("conversations: ", conversations);
    console.log("filteredUsers: ", filteredUser);
    console.log("messages: ", messages);


    // Add another useEffect to handle direct logout scenarios
    useEffect(() => {
        const userData = reactLocalStorage.getObject("userData");
        // Check if user is logged out
        if (!userData || Object.keys(userData).length === 0 || !userData.token) {
            setUnreadMessageLength(0);
        }
    }, [reactLocalStorage.getObject("userData")]);

    useEffect(() => {
        if (conversations?.length && filteredUser?.length) {
            const unreadCount = conversations.filter(conv =>
                !conv.read &&
                filteredUser &&
                filteredUser.some(user => user.email === conv.withUser)
            ).length;

            // console.log("unreadCount:>>>>> ", unreadCount);


            setUnreadMessageLength(unreadCount);
        } else {
            setUnreadMessageLength(0);
        }
    }, [conversations, filteredUser]);

    return (
        <>
            <div className='chatbox_main' ref={chatboxRef}>
                <div className='chatbox_wrapper' >
                    <div style={{
                        width: '25px',
                        height: '25px',
                        borderRadius: '50%',
                        background: 'red',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: 'white',
                        position: "absolute",
                        top: '0',
                        right: '0',
                        // display: conversations.some(c => !c.read && c?.withUser === localStorage.getItem("userEmail")) ? 'flex' : 'none',
                        display: unreadMessageLength && conversations.some(conv =>
                            !conv.read &&
                            filteredUser &&
                            filteredUser.some(user => user.email === conv.withUser)
                        ) ? 'flex' : 'none',
                    }}>
                        {/* {conversations.filter(c => !c.read).length} */}
                        {/* {conversations.filter(conv =>
                            !conv.read &&
                            filteredUser &&
                            filteredUser.some(user => user.email === conv.withUser)
                        ).length} */}
                        {unreadMessageLength}
                    </div>
                    <i onClick={handleChatClick} class="fa-solid fa-comment"></i>
                </div>

                {opensmallChat && <div className='chatox_messages_wrapper' ref={smallChatRef}>
                    <div className='chatbot_super_heading_wrapper' style={{
                        position: 'relative'
                    }}>
                        {modalIsopen && <ChatBoxModal
                            chatBoxModalRef={chatBoxModalRef}
                            setModalIsOpen={setModalIsOpen}
                            assignedProjects={assignedProjects}
                        />}
                        <div className='chatbot_heading_wrapper'>
                            <div className='fisibilty_logo_icon_wrapper'>
                                <img style={{
                                    border: '2px solid #0c2637',
                                    borderRadius: '50%',
                                    width: '30px',
                                    height: '30px',
                                    objectFit: 'cover'
                                }} src={userList?.find(item => item?.email === selectedReceiver?.email)?.profilePicture ? userList?.find(item => item?.email === selectedReceiver?.email)?.profilePicture : FisProjectsIcon} alt='...' />
                                <div style={{
                                    width: 'calc(100%-40px)'
                                }}>
                                    <h1>{selectedReceiver?.email?.split("@")[0] || "Anonymous"}</h1>
                                    {
                                        selectedReceiver?.phoneNumber && (
                                            <div className=''>
                                                <div className='fisibilty_logo_icon_wrapper'>
                                                    <h1 style={{
                                                        fontSize: '10px'
                                                    }}>Contact No: {selectedReceiver?.phoneNumber || "-"}</h1>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>

                            </div>
                            <i onClick={(() => {
                                setopensmallChat(!true);
                                setModalIsOpen(false);
                            })} class="fa-solid fa-xmark"></i>
                        </div>


                        {
                            selectedReceiver?.projects?.length && (
                                <small onClick={(() => {
                                    if (selectedReceiver?.projects?.length) {
                                        setModalIsOpen(!modalIsopen);
                                        setAssignedProjects(selectedReceiver?.projects);
                                    }
                                })} style={{
                                    fontSize: '12px',
                                    color: '#fff',
                                    fontWeight: '600',
                                    display: 'block',
                                    marginLeft: 'auto',
                                    marginRight: '10px',
                                    marginTop: '-10px',
                                    marginBottom: '10px'
                                }}>No of projects assigned: {selectedReceiver?.projects?.length || 0}</small>
                            )
                        }

                    </div>

                    <div className='chatbot_messages_container'>
                        {messages.map((message, i) => (
                            <div
                                key={i}
                                className={`chatbot_owner_message_div ${message.sender === currentUser?.email ? 'sent' : 'received'}`}
                                style={{
                                    flexDirection: message.sender === currentUser?.email ? 'row-reverse' : 'row'
                                }}
                            >
                                <div className='chatbot_user_img'>
                                    {/* <img src={
                                        message.sender === currentUser?.email ? smallimg2 : smallimg
                                    } alt={FisProjectsIcon} /> */}

                                    <img src={
                                        message.sender === currentUser?.email ? userList?.find(item => item?.email === currentUser?.email)?.profilePicture ? userList?.find(item => item?.email === currentUser?.email)?.profilePicture : (profileData && profileData?.profilePicture?.length > 0) ? profileData?.profilePicture : FisProjectsIcon : userList?.find(item => item?.email === message?.sender)?.profilePicture ? userList?.find(item => item?.email === message?.sender)?.profilePicture : FisProjectsIcon
                                    } alt={"..."} />
                                </div>
                                <div className='chatbot_message_content'>
                                    <div className={`chatbot_user_message ${message.fileUrl ? 'has-file' : ''}`}>
                                        {renderMessageContent(message)}
                                    </div>
                                    <div className='chatbot_message_time'>{formatDate(message.timestamp)}</div>
                                </div>
                            </div>
                        ))}
                        {previewUrl && renderFilePreview()}
                        <div ref={messagesEndRef} />
                    </div>

                    <div className='chatbot_messsage_send_div'>
                        <input
                            type='text'
                            placeholder='Enter your message ...'
                            value={msg}
                            onChange={e => setMsg(e?.target?.value)}
                            onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                        />
                        <label htmlFor="file-upload" className="file-upload-button">
                            <i className="fa-solid fa-paperclip"></i>
                        </label>
                        <input
                            id="file-upload"
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            accept="image/*,.pdf,.doc,.docx"
                            style={{ display: 'none' }}
                        />
                        <i
                            class="fa-solid fa-paper-plane"
                            onClick={sendMessage}
                        ></i>
                    </div>
                </div>}

                {openChat && <>
                    <div className='chat_box_list_wrapper'>
                        <div className='chats_header_Wrapper' style={{
                            justifyContent: 'center'
                        }}>
                            {/* <img style={{
                                width: '20px'
                            }} src={plus} alt='...' /> */}
                            <h1>Chats</h1>
                            <img style={{
                                width: '20px',
                                // visibility: 'hidden'
                                display: 'none'
                            }} src={plus} alt='...' />
                        </div>
                        <div className='chat-search-container'>
                            <input
                                type='text'
                                placeholder='Search users...'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className='chat-search-input'
                                style={{
                                    border: '3px solid #fff',
                                    borderRadius: '10px'
                                }}
                            />
                            <i className="fa-solid fa-magnifying-glass chat-search-icon"></i>
                        </div>

                        <div className='chat_list_box_wrapper'>
                            {loader && (
                                <div onClick={(() => { setopensmallChat(true) })} className='chat_list_box'>
                                    <div className='chat_list_user_img_Details_wrapper'>
                                        <div className='chabox_name_list_wrapper'>
                                            <h6>Loading ...</h6>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {filteredUser?.length > 0 && filteredUser?.map((user, i) => {
                                const unreadCount = conversations.find(c =>
                                    c.withUser === user.email ||
                                    generateChatId(currentUser?.email, user.email) === c.chatId
                                )?.read === false ? 1 : 0;

                                return (
                                    <React.Fragment key={i}>
                                        <div onClick={() => {
                                            selectUser(user);
                                            setModalIsOpen(false);
                                        }} className='chat_list_box'>
                                            <div className='chat_list_user_img_Details_wrapper'>
                                                <img src={user?.profilePicture ? user?.profilePicture : FisProjectsIcon} alt='...' />
                                                <div className='chabox_name_list_wrapper'>
                                                    <h6>{user.email?.split('@')[0] || "Anonymous"}</h6>
                                                    <p className="last-message-preview">
                                                        {user.lastMessage?.length > 30
                                                            ? `${user.lastMessage.substring(0, 30)}...`
                                                            : user.lastMessage}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='chat_list_user_time_date_wrappr'>
                                                <p>{formatDate(user.timestamp)}</p>
                                                {unreadCount > 0 && (
                                                    <div className="unread-badge">{unreadCount}</div>
                                                )}
                                                <p style={{
                                                    fontSize: '8px'
                                                }}>{user?.teamMember && `${user?.teamMember}- `}{userAccountTypes?.includes(user?.accountType) ? user?.accountType : user?.userType || '-'}</p>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            })}
                            {
                                filteredUser?.length === 0 && !loader && (
                                    <div onClick={(() => { setopensmallChat(true) })} className='chat_list_box'>
                                        <div className='chat_list_user_img_Details_wrapper'>
                                            <div className='chabox_name_list_wrapper'>
                                                <h6>No Contacts Found ...</h6>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </>}
            </div>
        </>
    )
}

export default Chatbox